import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {useMutation, useQuery, useQueryClient} from 'react-query'
import {Link} from 'react-router-dom'
import {toast} from 'react-toastify'
import {PageTitle} from '../../../../_metronic/layout/core'
import {KTSVG} from '../../../../_metronic/helpers'
import {Dropdown, InputDefault, TableDefault} from '../../../components/ui'
import FilterMenu from '../../../components/sections/FilterMenu'
import {
  getListTransactions,
  exportTransactions,
  Filter,
  reverseTransactionsById,
} from '../../../modules/services/transactions.service'
import {getBreadCrumbs} from '../breadcrumbs'
import jsonToCsv from '../../../utils/jsonToCsv'
import download from '../../../utils/download'
import {filtersMock} from '../../../mocks'
import {StatisticsWidget5} from '../../../../_metronic/partials/widgets'
import {getDepartment} from '../../../modules/services/product.service'
import {getUserProfileDept} from '../../../modules/services/userprofile.service'
import {convertToRupiah} from '../../../../_metronic/helpers/currency'
import {getDepartmentById} from '../../../modules/services/department.service'
import {getConfigDetail} from '../../../modules/services/configs.service'

const UserPointPage = () => {
  const queryClient = useQueryClient()
  const headFields = ['Name', 'Activities', 'Date', 'Points']
  const bodyFields = ['Member.fullname', 'campaign', 'TransactionDate', 'TotalPoint']
  const [filter, setFilter] = useState<Filter>({field: null, type: null})
  const [search, setSearch] = useState('')
  const [page, setPage] = useState(1),
    [department, setDepartment] = useState('1'),
    [startDate, setStartDate] = useState('2023-01-20'),
    [endDate, setEndDate] = useState('2023-11-22')

  const {data: departmentdata} = useQuery(['getDepartment'], async () => await getDepartment())
  const {data: dataProfile} = useQuery(
    ['getProfileDept', department, startDate, endDate],
    async () => await getUserProfileDept(department, startDate, endDate)
  )
  const {data: departmentId} = useQuery(
    ['getDepartmentId', department],
    async () => await getDepartmentById(department)
  )
  const {data: configData} = useQuery(['getConfig', '1'], async () => await getConfigDetail('1'))

  useEffect(() => {
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])

  const {data, isLoading} = useQuery(['getTransactions', search, filter, page], async () =>
    getListTransactions(search, page, filter)
  )
  const datas: any = data?.data
  const pageCount = data?.meta?.pagination.pageCount

  const handleDelete = (item: any) => {
    let datas = {
      id: item.id,
      memberId: item.attributes.Member.data?.id,
    }
    mutate(datas)
  }

  const exportData = async () => {
    const response = await exportTransactions()
    const data = (response.data as Array<any>).map((tx) => ({
      memberName: tx.attributes.Member.data.attributes.fullname,
      Member: undefined,
      Reversed: tx.attributes.Reversed,
      Status: tx.attributes.Status,
      TotalPoint: tx.attributes.TotalPoint,
      TotalTransaction: tx.attributes.TotalTransaction,
      TransactionDate: tx.attributes.TransactionDate,
      Qty: tx.attributes?.transaction_details?.data?.map((e: any) => e.attributes.Qty).toString(),
    }))
    const csv = jsonToCsv(data)
    download(csv, `${new Date().getTime()}-transactions.csv`, 'text/csv')
  }

  const {mutate, isLoading: loading} = useMutation((id: any) => reverseTransactionsById(id), {
    onSuccess: async () => {
      // buttonRef.current?.click()
      toast.success('Reverse Data Succes')
      await queryClient.invalidateQueries('getRedemptionList')
    },
    onError(error: any, variables, context) {
      console.log('Error', error.response?.data)
      toast.error(error.response?.data?.error?.message)
    },
  })

  const nextPage = () => {
    setPage(page + 1)
  }
  const prevPage = () => {
    setPage(page - 1)
  }
  const totalPerc = dataProfile?.percentage * 100
  const totalPointBudget = convertToRupiah(dataProfile?.pointAvailable)

  return (
    <>
      <div className='card mb-10'>
        <div className='card-body align-items-center py-8'>
          <div className='ms-6 row g-xl-12 align-items-center'>
            <p className='col-xl-2 fw-bold fs-6 p-0 m-0'>Point Generation</p>
            <div className='col-xl-6 d-flex px-2'>
              <p className='fw-bold fs-6 p-0 m-0 mx-2'>Date Range</p>
              <InputDefault
                id={'start-date'}
                type='date'
                placeholder='Start Date'
                onChange={(e: any) => setStartDate(e.target.value)}
                value={startDate}
              />
              <InputDefault
                id={'end-date'}
                type='date'
                placeholder='End Date'
                onChange={(e: any) => setEndDate(e.target.value)}
                value={endDate}
              />
            </div>
            <div className='col-xl-4 d-flex align-items-center'>
              <span className='fw-bold fs-6 p-0 m-0 mx-2'>Department</span>
              <Dropdown
                id={'department'}
                data={departmentdata}
                onChanges={(e: any) => setDepartment(e.target.value)}
                value={department}
              />
            </div>
          </div>
          <div className='row g-5 mt-5 mx-5 g-xl-12'>
            <div className='col-xl-4'>
              <StatisticsWidget5
                className='card-xl-stretch mb-xl-8'
                svgIcon='/media/icons/duotune/ecommerce/ecm008.svg'
                color='blues'
                iconColor='white'
                fontSizeTitle='fs-1'
                title={`${
                  new Intl.NumberFormat('en-ID', {
                    style: 'currency',
                    currency: 'IDR',
                  }).format(departmentId?.attributes?.annual_budget) ?? 0
                }`}
                // title='IDR 160.000.000'
                description='Total Departments Budget'
              />
            </div>
            <div className='col-xl-4'>
              <StatisticsWidget5
                className='card-xl-stretch mb-xl-8'
                svgIcon='/media/icons/duotune/ecommerce/ecm008.svg'
                color='greens'
                iconColor='white'
                title={`${totalPointBudget} PTS`}
                // title='15.000 PTS'
                description='Total Available Point'
              />
            </div>
            <div className='col-xl-4'>
              <StatisticsWidget5
                className='card-xl-stretch mb-xl-8'
                svgIcon='/media/icons/duotune/ecommerce/ecm008.svg'
                color='reds'
                iconColor='white'
                // title={transactions[0]?.value ?? 0}
                title={`${totalPerc.toFixed(2) ?? 0} %`}
                description='Departments Budget Spending Propotion'
              />
            </div>
          </div>
        </div>
        {!isLoading && (
          <TableDefault
            head={headFields}
            body={bodyFields}
            data={dataProfile?.members}
            href={''}
            isWithAction={true}
            allPaginate={1}
            customBtnAction='Void'
            // page={page}
            // setsPage={setPage}
            // nextPage={nextPage}
            // prevPage={prevPage}
            loadings={loading}
          />
        )}
      </div>
    </>
  )
}

const UserPointWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle>{intl.formatMessage({id: 'MENU.USERPOINTS'})}</PageTitle>
      <UserPointPage />
    </>
  )
}

export default UserPointWrapper
